'use client'
import { useProductMetadata } from '@/components/LayoutWithMenu/productMetadataHooks'
import { SelectInsuranceGrid } from '@/components/SelectInsuranceGrid/SelectInsuranceGrid'
import { ProductFragment } from '@/services/graphql/generated'
import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { storyblokEditable } from '@storyblok/react'
import { grid } from './SelectInsuranceGridBlock.css'

type Props = SbBaseBlockProps<{
  products?: Array<string> // list of product names
  title?: string
  openPriceCalculator?: boolean
}>

export function SelectInsuranceGridBlock({ blok, nested }: Props) {
  const allProducts = useProductMetadata()
  const openPriceCalculator = blok.openPriceCalculator ?? true

  const selectedProducts = blok.products ?? []
  let products: Array<ProductFragment> = allProducts ?? []
  if (selectedProducts.length > 0) {
    const productsByName = new Map(products.map((item) => [item.name, item]))

    // Keep order of selected products
    products = []
    for (const productName of selectedProducts) {
      const product = productsByName.get(productName)
      if (product) {
        products.push(product)
      }
    }
  }

  return (
    <SelectInsuranceGrid
      className={grid}
      data-nested={nested}
      heading={blok.title}
      products={products}
      openPriceCalculator={openPriceCalculator}
      {...storyblokEditable(blok)}
    />
  )
}
